import * as React from 'react'

import { PopoverContent } from '~/client/src/shared/components/shadcn-ui/popover'
import { TooltipContent } from '~/client/src/shared/components/shadcn-ui/tooltip'

// In browser-fullscreen, popovers must portal into the fullscreen element —
// the Fullscreen API hides anything portaled to document.body behind it.
export const MarkupPortalContainerContext =
  React.createContext<HTMLElement | null>(null)

export const useMarkupPortalContainer = (): HTMLElement | null =>
  React.useContext(MarkupPortalContainerContext)

export function MarkupPopoverContent(
  props: React.ComponentProps<typeof PopoverContent>,
): JSX.Element {
  return (
    <PopoverContent
      portalContainer={useMarkupPortalContainer() ?? undefined}
      {...props}
    />
  )
}

export function MarkupTooltipContent(
  props: React.ComponentProps<typeof TooltipContent>,
): JSX.Element {
  return (
    <TooltipContent
      portalContainer={useMarkupPortalContainer() ?? undefined}
      {...props}
    />
  )
}
